import {
  DollarOutlined,
  FileTextOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import s from "./TodayReport.module.css";

export default function TodayReport({ dashboardData }) {
  const authData = JSON.parse(localStorage.getItem("auth"));
  const username = authData?.full_name;

  const cards = [
    {
      key: "me",
      color: "#FCE9F0",
      iconBg: "#F6D5E0",
      icon: <UserOutlined />,
      title: `Hi, ${username}`,
      subtitle: "My Details",
      link: "Employee Dashboard",
    },
    {
      key: "quotations",
      color: "#FEF1DC",
      iconBg: "#FDE7C6",
      icon: <FileTextOutlined />,
      title: dashboardData?.summary?.quotation_value || "0",
      subtitle: "Quotations",
      link: "Total Quotations",
    },
    {
      key: "revenue",
      color: "#E6F8EB",
      iconBg: "#D6F2DE",
      icon: <DollarOutlined />,
      title: dashboardData?.summary?.total_revenue || "0",
      subtitle: "Revenue",
      link: "Total Revenue",
    },
    {
      key: "expenses",
      color: "#F0E9FF",
      iconBg: "#E7DFFF",
      icon: <TeamOutlined />,
      title: dashboardData?.summary?.total_expenses || "0",
      subtitle: "Expenses",
      link: "Total Expenses",
    },
    {
      key: "docs",
      color: "#FEF1DC",
      iconBg: "#FDE7C6",
      icon: <FileTextOutlined />,
      title: dashboardData?.summary?.net_profit || "0",
      subtitle: "Profit",
      link: "Net Profit",
    },
  ];

  return (
    <div className={s.wrap}>
      <div className={s.header}>
        <div>
          <div className={s.title}>Today’s Report</div>
          <div className={s.sub}>Report Summary</div>
        </div>
        <Button icon={<UploadOutlined />} className={s.exportBtn}>
          Export
        </Button>
      </div>

      <div className={s.grid}>
        {cards.map((c) => (
          <div key={c.key} className={s.card} style={{ background: c.color }}>
            <div className={s.cardTop}>
              <div className={s.icon} style={{ background: c.iconBg }}>
                {c.icon}
              </div>
              <div className={s.texts}>
                <div className={s.kpiValue}>{c.title}</div>
                <div className={s.kpiTitle}>{c.subtitle}</div>
              </div>
            </div>

            <button type="button" className={s.linkFull}>
              {c.link}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
